var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: _vm.title, visible: _vm.dialogVisible, width: "40em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("UserMasterForm", {
              ref: "userForm",
              attrs: {
                "label-width": "10em",
                formMode: "edit",
                programName: _vm.programName,
                forgotPassword: _vm.forgotPassword
              },
              model: {
                value: _vm.userFormModel,
                callback: function($$v) {
                  _vm.userFormModel = $$v
                },
                expression: "userFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [_c("EditDialogFooter", { on: { update: _vm.clickUpdate } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }